import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const costPlugin = createPlugin({
  id: 'zf-cost-scorecard',
  routes: {
    root: rootRouteRef,
  },
});

export const CostScorecardPage = costPlugin.provide(
  createRoutableExtension({
    name: 'CostScorecardPage',
    component: () =>
      import('./components/costScoreCardTeam/CostScorecard').then(m => m.CostScorecard),
    mountPoint: rootRouteRef,
  }),
);
